export default "__VITE_ASSET__BFyN1ion__"